import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import { useTranslation } from 'react-i18next';

export type EurailTravellersCount = {
  child: number;
  youth: number;
  adult: number;
  senior: number;
};

export enum EurailTravellerIncrementFields {
  child = 'child',
  youth = 'youth',
  adult = 'adult',
  senior = 'senior',
}

export type TravellerSelector = ElementsSDK.IncrementProps & {
  id: string;
};

export function useTravellersSelector(travellersCount: EurailTravellersCount) {
  const { t } = useTranslation();

  const travellerIncrements: TravellerSelector[] = [
    {
      id: EurailTravellerIncrementFields.youth,
      label: t('eurail.travellers.youth'),
      value: travellersCount.youth,
      min: 0,
      max: undefined,
      onChange() {},
      tooltip: t('eurail.travellers.youth.tooltip').replace(/\\n/g, '<br>'),
    },
    {
      id: EurailTravellerIncrementFields.adult,
      label: t('eurail.travellers.adult'),
      value: travellersCount.adult,
      min: 0,
      max: undefined,
      onChange() {},
    },
    {
      id: EurailTravellerIncrementFields.child,
      label: t('eurail.travellers.child'),
      value: travellersCount.child,
      min: 0,
      max: 2,
      onChange() {},
    },
    {
      id: EurailTravellerIncrementFields.senior,
      label: t('eurail.travellers.senior'),
      value: travellersCount.senior,
      min: 0,
      max: undefined,
      onChange() {},
    },
  ];

  return {
    travellerIncrements,
  };
}
